module.exports = __webpack_public_path__ + "static/media/launch.da149293.jpg";